import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { useState } from "react"
import { NewText } from "ui"
import { extractProperty } from "utils"
import DownloadProgressDialog from "./DownloadProgressDialog"

type SelectedFilesFloatingBarProps = {
  selectedCount: number
  messages: any
  onDownloadSelected: () => void
  downloadProgress: any
  totalFiles: any
  filteredFiles: any
}

const StyledDownloadSection = styled.div`
  position: fixed;
  bottom: 10px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
  left: 50%;
  transform: translate(-50%, 0px);
  box-shadow: 0px 4px 8px 0px #00000029;
  background-color: white;
  border-radius: 85px;
  height: 64px;
  padding: 8px;
  padding-left: 25px;
  ${(props) => props.theme.breakpoints.down("md")} {
    width: calc(100% - 32px);
  }
`

const StyledDownloadSelectedButton = styled(Button)`
  height: 48px;
  border-radius: 200px;
  padding-left: 16px;
  padding-right: 16px;
  background-color: #2768a3;
  color: white;
  text-decoration: none;
  font-size: 18px;
  :hover {
    text-decoration: none;
    background-color: #2768a3;
    color: white;
  }
`

const SelectedFilesFloatingBar = ({
  selectedCount,
  messages,
  onDownloadSelected,
  downloadProgress,
  totalFiles,
  filteredFiles,
}: SelectedFilesFloatingBarProps) => {
  const [open, setOpen] = useState(false)
  if (selectedCount === 0) return null

  // Get file name if there's only one file
  const getFileName = () => {
    if (filteredFiles.length === 1) {
      return extractProperty(filteredFiles[0]?.file, "fileName")
    }
    return undefined
  }
  return (
    <StyledDownloadSection>
      <NewText component={"p"} desktopFontSize={18} desktopFontWeight={600} color="#000000">
        {selectedCount} {messages.filesSelected}
      </NewText>
      <StyledDownloadSelectedButton
        onClick={() => {
          onDownloadSelected()
          setOpen(true)
        }}
      >
        {messages.selectedFilesDownload}
      </StyledDownloadSelectedButton>
      <DownloadProgressDialog
        open={open}
        onClose={() => setOpen(false)}
        downloadProgress={downloadProgress}
        selectedCount={selectedCount}
        totalFiles={totalFiles}
        messages={messages}
        fileName={getFileName()}
      />
    </StyledDownloadSection>
  )
}

export default SelectedFilesFloatingBar
